export class EnabledFeatures{
  enableChangeRequest: boolean;

  constructor(enabledFeatures: IEnabledFeatures){
    this.enableChangeRequest = enabledFeatures === undefined || enabledFeatures.enableChangeRequest === undefined ? false : enabledFeatures.enableChangeRequest;
  }
}


export interface IEnabledFeatures{
  enableChangeRequest: boolean;
}